import {numberFormatsListItems} from '../../../../util/uiconstants';

export default () => numberFormatsListItems.map(({label, id}) => ({id: id === 0 ? 999 : id, value: id, label: label}));
